import React from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

export const getShareLinks = (url, title, handleMore) => {
  const shareMessage = `Take a look at this ${title} on Kidilan Traveler: `;
  const fullMessage = `${shareMessage}${url}`;

  return [
    {
      name: "WhatsApp",
      icon: <WhatsAppIcon />,
      color: "bg-[#25D366]",
      link: `https://wa.me/?text=${encodeURIComponent(fullMessage)}`,
    },
    {
      name: "Facebook",
      icon: <FacebookIcon />,
      color: "bg-[#1877F2]",
      link: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    },
    {
      name: "X",
      icon: <XIcon />,
      color: "bg-[#000000]",
      link: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(shareMessage)}`,
    },
    {
      name: "More",
      icon: <MoreHorizIcon />,
      color: "bg-[#0f172a]",
      onClick: handleMore,
    },
  ];
};
